// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var StringHelper = require("./StringHelper");
var Plate$BwaxMobile = require("../../../plate.bs.js");
var Lang_eval$BwaxMobile = require("../../lang_eval.bs.js");
var Runtime_common$BwaxMobile = require("../runtime_common.bs.js");
var Lang_typing_base$BwaxMobile = require("../../lang_typing_base.bs.js");

function toBase64(prim) {
  return StringHelper.toBase64(prim);
}

function toBase64URI(prim) {
  return StringHelper.toBase64URI(prim);
}

function fromBase64(prim) {
  return StringHelper.fromBase64(prim);
}

function addQueryParam(prim, prim$1, prim$2) {
  return StringHelper.addQueryParam(prim, prim$1, prim$2);
}

function removeQueryParam(prim, prim$1) {
  return StringHelper.removeQueryParam(prim, prim$1);
}

function isValidHttpURL(prim) {
  return StringHelper.isValidHttpURL(prim);
}

function hashCode(prim) {
  return StringHelper.hashCode(prim);
}

function fail(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        "String." + (name + ": Invalid Arguments")
      ];
}

function int_to_string_to_string(proc, name) {
  var func = function (param) {
    if (param) {
      var match = param[0][0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return fail(name);
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || match$1.tag) {
          return fail(name);
        } else {
          var match$2 = param[1];
          if (match$2) {
            var match$3 = match$2[0][0];
            if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
              return fail(name);
            } else {
              var match$4 = match$3[0];
              if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
                return fail(name);
              } else {
                var result = Curry._2(proc, match$1[0], match$4[0]);
                return /* tuple */[
                        /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
                        Lang_typing_base$BwaxMobile.string
                      ];
              }
            }
          } else {
            return fail(name);
          }
        }
      }
    } else {
      return fail(name);
    }
  };
  return Runtime_common$BwaxMobile.pack_func(2, func);
}

function string_to_string_to_bool(proc, name) {
  var func = function (param) {
    if (param) {
      var match = param[0][0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return fail(name);
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
          return fail(name);
        } else {
          var match$2 = param[1];
          if (match$2) {
            var match$3 = match$2[0][0];
            if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
              return fail(name);
            } else {
              var match$4 = match$3[0];
              if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
                return fail(name);
              } else {
                var result = Curry._2(proc, match$1[0], match$4[0]);
                return /* tuple */[
                        /* V_literal */Block.__(5, [/* Bool */Block.__(4, [result])]),
                        Lang_typing_base$BwaxMobile.bool
                      ];
              }
            }
          } else {
            return fail(name);
          }
        }
      }
    } else {
      return fail(name);
    }
  };
  return Runtime_common$BwaxMobile.pack_func(2, func);
}

function string_to_string(proc, name) {
  var func = function (param) {
    if (param) {
      var match = param[0][0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return fail(name);
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
          return fail(name);
        } else {
          var result = Curry._1(proc, match$1[0]);
          return /* tuple */[
                  /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
                  Lang_typing_base$BwaxMobile.string
                ];
        }
      }
    } else {
      return fail(name);
    }
  };
  return /* tuple */[
          name,
          Runtime_common$BwaxMobile.pack_func(1, func)
        ];
}

function string_to_int(proc, name) {
  var func = function (args) {
    if (args) {
      var match = args[0][0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return fail(name);
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !args[1])) {
          return fail(name);
        } else {
          return /* tuple */[
                  /* V_literal */Block.__(5, [/* Int */Block.__(0, [Curry._1(proc, match$1[0])])]),
                  Lang_typing_base$BwaxMobile.$$int
                ];
        }
      }
    } else {
      return fail(name);
    }
  };
  return /* tuple */[
          name,
          Runtime_common$BwaxMobile.pack_func(1, func)
        ];
}

function int_char_string_string(proc, name) {
  var func = function (param) {
    if (param) {
      var match = param[0][0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return fail(name);
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || match$1.tag) {
          return fail(name);
        } else {
          var match$2 = param[1];
          if (match$2) {
            var match$3 = match$2[0][0];
            if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
              return fail(name);
            } else {
              var match$4 = match$3[0];
              if (typeof match$4 === "number" || match$4.tag !== /* Char */3) {
                return fail(name);
              } else {
                var match$5 = match$2[1];
                if (match$5) {
                  var match$6 = match$5[0][0];
                  if (typeof match$6 === "number" || match$6.tag !== /* V_literal */5) {
                    return fail(name);
                  } else {
                    var match$7 = match$6[0];
                    if (typeof match$7 === "number" || !(match$7.tag === /* String */2 && !match$5[1])) {
                      return fail(name);
                    } else {
                      var result = Curry._3(proc, match$1[0], match$4[0], match$7[0]);
                      return /* tuple */[
                              /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
                              Lang_typing_base$BwaxMobile.string
                            ];
                    }
                  }
                } else {
                  return fail(name);
                }
              }
            }
          } else {
            return fail(name);
          }
        }
      }
    } else {
      return fail(name);
    }
  };
  return /* tuple */[
          name,
          Runtime_common$BwaxMobile.pack_func(3, func)
        ];
}

function func(args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("split");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
        return fail("split");
      } else {
        var match$2 = args[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
            return fail("split");
          } else {
            var match$4 = match$3[0];
            if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
              return fail("split");
            } else {
              var l = Plate$BwaxMobile.List.map((function (s) {
                      return /* tuple */[
                              /* V_literal */Block.__(5, [/* String */Block.__(2, [s])]),
                              Lang_typing_base$BwaxMobile.string
                            ];
                    }), Plate$BwaxMobile.Str.split(match$1[0], match$4[0]));
              return /* tuple */[
                      /* V_list */Block.__(1, [l]),
                      Lang_typing_base$BwaxMobile.list(Lang_typing_base$BwaxMobile.string)
                    ];
            }
          }
        } else {
          return fail("split");
        }
      }
    }
  } else {
    return fail("split");
  }
}

function func$1(args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("join");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
        return fail("join");
      } else {
        var match$2 = args[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || !(match$3.tag === /* V_list */1 && !match$2[1])) {
            return fail("join");
          } else {
            var strs = Plate$BwaxMobile.List.keep_map((function (param) {
                    var match = param[0];
                    if (typeof match === "number" || match.tag !== /* V_literal */5) {
                      return ;
                    } else {
                      var match$1 = match[0];
                      if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
                        return ;
                      } else {
                        return match$1[0];
                      }
                    }
                  }), match$3[0]);
            var joined = Plate$BwaxMobile.Str.join(match$1[0], strs);
            return /* tuple */[
                    /* V_literal */Block.__(5, [/* String */Block.__(2, [joined])]),
                    Lang_typing_base$BwaxMobile.string
                  ];
          }
        } else {
          return fail("join");
        }
      }
    }
  } else {
    return fail("join");
  }
}

function func$2(args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("replace");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
        return fail("replace");
      } else {
        var match$2 = args[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
            return fail("replace");
          } else {
            var match$4 = match$3[0];
            if (typeof match$4 === "number" || match$4.tag !== /* String */2) {
              return fail("replace");
            } else {
              var match$5 = match$2[1];
              if (match$5) {
                var match$6 = match$5[0][0];
                if (typeof match$6 === "number" || match$6.tag !== /* V_literal */5) {
                  return fail("replace");
                } else {
                  var match$7 = match$6[0];
                  if (typeof match$7 === "number" || !(match$7.tag === /* String */2 && !match$5[1])) {
                    return fail("replace");
                  } else {
                    var r = Plate$BwaxMobile.Str.replace(match$1[0], match$4[0], match$7[0]);
                    return /* tuple */[
                            /* V_literal */Block.__(5, [/* String */Block.__(2, [r])]),
                            Lang_typing_base$BwaxMobile.string
                          ];
                  }
                }
              } else {
                return fail("replace");
              }
            }
          }
        } else {
          return fail("replace");
        }
      }
    }
  } else {
    return fail("replace");
  }
}

function func$3(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("slice");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag) {
        return fail("slice");
      } else {
        var match$2 = param[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
            return fail("slice");
          } else {
            var match$4 = match$3[0];
            if (typeof match$4 === "number" || match$4.tag) {
              return fail("slice");
            } else {
              var match$5 = match$2[1];
              if (match$5) {
                var match$6 = match$5[0][0];
                if (typeof match$6 === "number" || match$6.tag !== /* V_literal */5) {
                  return fail("slice");
                } else {
                  var match$7 = match$6[0];
                  if (typeof match$7 === "number" || !(match$7.tag === /* String */2 && !match$5[1])) {
                    return fail("slice");
                  } else {
                    var result = Plate$BwaxMobile.Str.slice(match$1[0], match$4[0], match$7[0]);
                    return /* tuple */[
                            /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
                            Lang_typing_base$BwaxMobile.string
                          ];
                  }
                }
              } else {
                return fail("slice");
              }
            }
          }
        } else {
          return fail("slice");
        }
      }
    }
  } else {
    return fail("slice");
  }
}

function func$4(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("indexes");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
        return fail("indexes");
      } else {
        var match$2 = param[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
            return fail("indexes");
          } else {
            var match$4 = match$3[0];
            if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
              return fail("indexes");
            } else {
              var result = Plate$BwaxMobile.List.map((function (i) {
                      return /* tuple */[
                              /* V_literal */Block.__(5, [/* Int */Block.__(0, [i])]),
                              Lang_typing_base$BwaxMobile.$$int
                            ];
                    }), Plate$BwaxMobile.Str.indexes(match$1[0], match$4[0]));
              return /* tuple */[
                      /* V_list */Block.__(1, [result]),
                      Lang_typing_base$BwaxMobile.list(Lang_typing_base$BwaxMobile.$$int)
                    ];
            }
          }
        } else {
          return fail("indexes");
        }
      }
    }
  } else {
    return fail("indexes");
  }
}

function func$5(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("toInt");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
        return fail("toInt");
      } else {
        var match$2 = Plate$BwaxMobile.Str.to_int(match$1[0]);
        var result = match$2 !== undefined ? Runtime_common$BwaxMobile.just(/* tuple */[
                /* V_literal */Block.__(5, [/* Int */Block.__(0, [match$2])]),
                Lang_typing_base$BwaxMobile.$$int
              ]) : Runtime_common$BwaxMobile.nothing;
        return /* tuple */[
                result,
                Runtime_common$BwaxMobile.nt
              ];
      }
    }
  } else {
    return fail("toInt");
  }
}

function func$6(args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || !(match.tag === /* V_literal */5 && !args[1])) {
      return fail("fromInt");
    } else {
      var l = match[0];
      var result;
      if (typeof l === "number") {
        switch (l) {
          case /* NaN */0 :
              result = "NaN";
              break;
          case /* Infinity */1 :
              result = "Infinity";
              break;
          case /* NegInfinity */2 :
              result = "-Infinity";
              break;
          
        }
      } else {
        switch (l.tag | 0) {
          case /* Int */0 :
              result = Plate$BwaxMobile.Str.from_int(l[0]);
              break;
          case /* Float */1 :
              result = Plate$BwaxMobile.Str.from_float(l[0]);
              break;
          default:
            result = fail("fromInt");
        }
      }
      return /* tuple */[
              /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
              Lang_typing_base$BwaxMobile.string
            ];
    }
  } else {
    return fail("fromInt");
  }
}

function func$7(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("toFloat");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
        return fail("toFloat");
      } else {
        var match$2 = Plate$BwaxMobile.Str.to_float(match$1[0]);
        var result = match$2 !== undefined ? Runtime_common$BwaxMobile.just(/* tuple */[
                /* V_literal */Block.__(5, [/* Float */Block.__(1, [match$2])]),
                Lang_typing_base$BwaxMobile.$$float
              ]) : Runtime_common$BwaxMobile.nothing;
        return /* tuple */[
                result,
                Runtime_common$BwaxMobile.nt
              ];
      }
    }
  } else {
    return fail("toFloat");
  }
}

function func$8(args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || !(match.tag === /* V_literal */5 && !args[1])) {
      return fail("fromFloat");
    } else {
      var l = match[0];
      var result;
      if (typeof l === "number") {
        switch (l) {
          case /* NaN */0 :
              result = "NaN";
              break;
          case /* Infinity */1 :
              result = "Infinity";
              break;
          case /* NegInfinity */2 :
              result = "-Infinity";
              break;
          
        }
      } else {
        switch (l.tag | 0) {
          case /* Int */0 :
              result = Plate$BwaxMobile.Str.from_int(l[0]);
              break;
          case /* Float */1 :
              result = Plate$BwaxMobile.Str.from_float(l[0]);
              break;
          default:
            result = fail("fromFloat");
        }
      }
      return /* tuple */[
              /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
              Lang_typing_base$BwaxMobile.string
            ];
    }
  } else {
    return fail("fromFloat");
  }
}

function func$9(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("fromChar");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || !(match$1.tag === /* Char */3 && !param[1])) {
        return fail("fromChar");
      } else {
        var result = Plate$BwaxMobile.Str.from_char(match$1[0]);
        return /* tuple */[
                /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
                Lang_typing_base$BwaxMobile.string
              ];
      }
    }
  } else {
    return fail("fromChar");
  }
}

function func$10(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("cons");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || match$1.tag !== /* Char */3) {
        return fail("cons");
      } else {
        var match$2 = param[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
            return fail("cons");
          } else {
            var match$4 = match$3[0];
            if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
              return fail("cons");
            } else {
              var result = Plate$BwaxMobile.Str.cons(match$1[0], match$4[0]);
              return /* tuple */[
                      /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
                      Lang_typing_base$BwaxMobile.string
                    ];
            }
          }
        } else {
          return fail("cons");
        }
      }
    }
  } else {
    return fail("cons");
  }
}

function func$11(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("uncons");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
        return fail("uncons");
      } else {
        var tuple_t = Lang_typing_base$BwaxMobile.tuple(/* :: */[
              Lang_typing_base$BwaxMobile.$$char,
              /* :: */[
                Lang_typing_base$BwaxMobile.string,
                /* [] */0
              ]
            ]);
        var match$2 = Plate$BwaxMobile.Str.uncons(match$1[0]);
        var result;
        if (match$2 !== undefined) {
          var match$3 = match$2;
          var c_val_000 = /* V_literal */Block.__(5, [/* Char */Block.__(3, [match$3[0]])]);
          var c_val = /* tuple */[
            c_val_000,
            Lang_typing_base$BwaxMobile.$$char
          ];
          var rest_val_000 = /* V_literal */Block.__(5, [/* String */Block.__(2, [match$3[1]])]);
          var rest_val = /* tuple */[
            rest_val_000,
            Lang_typing_base$BwaxMobile.string
          ];
          result = Runtime_common$BwaxMobile.just(/* tuple */[
                /* V_tuple */Block.__(0, [/* :: */[
                      c_val,
                      /* :: */[
                        rest_val,
                        /* [] */0
                      ]
                    ]]),
                tuple_t
              ]);
        } else {
          result = Runtime_common$BwaxMobile.nothing;
        }
        return /* tuple */[
                result,
                Runtime_common$BwaxMobile.nt
              ];
      }
    }
  } else {
    return fail("uncons");
  }
}

function func$12(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || match.tag !== /* V_literal */5) {
      return fail("toList");
    } else {
      var match$1 = match[0];
      if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
        return fail("toList");
      } else {
        var result = Plate$BwaxMobile.List.map((function (c) {
                return /* tuple */[
                        /* V_literal */Block.__(5, [/* Char */Block.__(3, [c])]),
                        Lang_typing_base$BwaxMobile.$$char
                      ];
              }), Plate$BwaxMobile.Str.to_list(match$1[0]));
        return /* tuple */[
                /* V_list */Block.__(1, [result]),
                Lang_typing_base$BwaxMobile.list(Lang_typing_base$BwaxMobile.$$char)
              ];
      }
    }
  } else {
    return fail("toList");
  }
}

function func$13(param) {
  if (param) {
    var match = param[0][0];
    if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
      return fail("fromList");
    } else {
      var result = Plate$BwaxMobile.Str.from_list(Plate$BwaxMobile.List.keep_map((function (param) {
                  var match = param[0];
                  if (typeof match === "number" || match.tag !== /* V_literal */5) {
                    return ;
                  } else {
                    var match$1 = match[0];
                    if (typeof match$1 === "number" || match$1.tag !== /* Char */3) {
                      return ;
                    } else {
                      return match$1[0];
                    }
                  }
                }), match[0]));
      return /* tuple */[
              /* V_literal */Block.__(5, [/* String */Block.__(2, [result])]),
              Lang_typing_base$BwaxMobile.string
            ];
    }
  } else {
    return fail("fromList");
  }
}

var externals_vals_000 = string_to_int(Plate$BwaxMobile.Str.length, "length");

var externals_vals_001 = /* :: */[
  string_to_int(hashCode, "hashCode"),
  /* :: */[
    /* tuple */[
      "repeat",
      int_to_string_to_string(Plate$BwaxMobile.Str.repeat, "repeat")
    ],
    /* :: */[
      /* tuple */[
        "split",
        Runtime_common$BwaxMobile.pack_func(2, func)
      ],
      /* :: */[
        /* tuple */[
          "join",
          /* tuple */[
            /* V_native_fn */Block.__(4, [
                2,
                func$1,
                /* [] */0
              ]),
            Runtime_common$BwaxMobile.nt
          ]
        ],
        /* :: */[
          /* tuple */[
            "replace",
            /* tuple */[
              /* V_native_fn */Block.__(4, [
                  3,
                  func$2,
                  /* [] */0
                ]),
              Runtime_common$BwaxMobile.nt
            ]
          ],
          /* :: */[
            /* tuple */[
              "slice",
              /* tuple */[
                /* V_native_fn */Block.__(4, [
                    3,
                    func$3,
                    /* [] */0
                  ]),
                Runtime_common$BwaxMobile.nt
              ]
            ],
            /* :: */[
              /* tuple */[
                "left",
                int_to_string_to_string(Plate$BwaxMobile.Str.left, "left")
              ],
              /* :: */[
                /* tuple */[
                  "right",
                  int_to_string_to_string(Plate$BwaxMobile.Str.right, "right")
                ],
                /* :: */[
                  /* tuple */[
                    "dropLeft",
                    int_to_string_to_string(Plate$BwaxMobile.Str.drop_left, "dropLeft")
                  ],
                  /* :: */[
                    /* tuple */[
                      "dropRight",
                      int_to_string_to_string(Plate$BwaxMobile.Str.drop_right, "dropRight")
                    ],
                    /* :: */[
                      /* tuple */[
                        "contains",
                        string_to_string_to_bool(Plate$BwaxMobile.Str.contains, "contains")
                      ],
                      /* :: */[
                        /* tuple */[
                          "startsWith",
                          string_to_string_to_bool(Plate$BwaxMobile.Str.starts_with, "startsWith")
                        ],
                        /* :: */[
                          /* tuple */[
                            "endsWith",
                            string_to_string_to_bool(Plate$BwaxMobile.Str.ends_with, "endsWith")
                          ],
                          /* :: */[
                            /* tuple */[
                              "indexes",
                              Runtime_common$BwaxMobile.pack_func(2, func$4)
                            ],
                            /* :: */[
                              /* tuple */[
                                "toInt",
                                Runtime_common$BwaxMobile.pack_func(1, func$5)
                              ],
                              /* :: */[
                                /* tuple */[
                                  "fromInt",
                                  Runtime_common$BwaxMobile.pack_func(1, func$6)
                                ],
                                /* :: */[
                                  /* tuple */[
                                    "toFloat",
                                    Runtime_common$BwaxMobile.pack_func(1, func$7)
                                  ],
                                  /* :: */[
                                    /* tuple */[
                                      "fromFloat",
                                      Runtime_common$BwaxMobile.pack_func(1, func$8)
                                    ],
                                    /* :: */[
                                      /* tuple */[
                                        "fromChar",
                                        Runtime_common$BwaxMobile.pack_func(1, func$9)
                                      ],
                                      /* :: */[
                                        /* tuple */[
                                          "cons",
                                          Runtime_common$BwaxMobile.pack_func(2, func$10)
                                        ],
                                        /* :: */[
                                          /* tuple */[
                                            "uncons",
                                            Runtime_common$BwaxMobile.pack_func(1, func$11)
                                          ],
                                          /* :: */[
                                            /* tuple */[
                                              "toList",
                                              Runtime_common$BwaxMobile.pack_func(1, func$12)
                                            ],
                                            /* :: */[
                                              /* tuple */[
                                                "fromList",
                                                Runtime_common$BwaxMobile.pack_func(1, func$13)
                                              ],
                                              /* :: */[
                                                string_to_string(Plate$BwaxMobile.Str.to_upper, "toUpper"),
                                                /* :: */[
                                                  string_to_string(Plate$BwaxMobile.Str.to_lower, "toLower"),
                                                  /* :: */[
                                                    string_to_string(Plate$BwaxMobile.Str.cap, "capitalize"),
                                                    /* :: */[
                                                      string_to_string(Plate$BwaxMobile.Str.decap, "uncapitalize"),
                                                      /* :: */[
                                                        int_char_string_string(Plate$BwaxMobile.Str.pad, "pad"),
                                                        /* :: */[
                                                          int_char_string_string(Plate$BwaxMobile.Str.pad_left, "padLeft"),
                                                          /* :: */[
                                                            int_char_string_string(Plate$BwaxMobile.Str.pad_right, "padRight"),
                                                            /* :: */[
                                                              string_to_string(Plate$BwaxMobile.Str.trim, "trim"),
                                                              /* :: */[
                                                                string_to_string(Plate$BwaxMobile.Str.trim_left, "trimLeft"),
                                                                /* :: */[
                                                                  string_to_string(Plate$BwaxMobile.Str.trim_right, "trimRight"),
                                                                  /* :: */[
                                                                    string_to_string(Plate$BwaxMobile.Str.reverse, "reverse"),
                                                                    /* :: */[
                                                                      string_to_string(toBase64, "toBase64"),
                                                                      /* :: */[
                                                                        string_to_string(toBase64URI, "toBase64URI"),
                                                                        /* :: */[
                                                                          string_to_string(fromBase64, "fromBase64"),
                                                                          /* :: */[
                                                                            string_to_string((function (prim) {
                                                                                    return encodeURI(prim);
                                                                                  }), "encodeURI"),
                                                                            /* :: */[
                                                                              string_to_string((function (prim) {
                                                                                      return decodeURI(prim);
                                                                                    }), "decodeURI"),
                                                                              /* :: */[
                                                                                string_to_string((function (prim) {
                                                                                        return encodeURIComponent(prim);
                                                                                      }), "encodeURIComponent"),
                                                                                /* :: */[
                                                                                  string_to_string((function (prim) {
                                                                                          return decodeURIComponent(prim);
                                                                                        }), "decodeURIComponent"),
                                                                                  /* :: */[
                                                                                    /* tuple */[
                                                                                      "addQueryParam",
                                                                                      Runtime_common$BwaxMobile.pack_func(3, (function (param) {
                                                                                              if (param) {
                                                                                                var match = param[0][0];
                                                                                                if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                                                                  return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                                } else {
                                                                                                  var match$1 = match[0];
                                                                                                  if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
                                                                                                    return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                                  } else {
                                                                                                    var match$2 = param[1];
                                                                                                    if (match$2) {
                                                                                                      var match$3 = match$2[0][0];
                                                                                                      if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
                                                                                                        return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                                      } else {
                                                                                                        var match$4 = match$3[0];
                                                                                                        if (typeof match$4 === "number" || match$4.tag !== /* String */2) {
                                                                                                          return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                                        } else {
                                                                                                          var match$5 = match$2[1];
                                                                                                          if (match$5) {
                                                                                                            var match$6 = match$5[0][0];
                                                                                                            if (typeof match$6 === "number" || match$6.tag !== /* V_literal */5) {
                                                                                                              return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                                            } else {
                                                                                                              var match$7 = match$6[0];
                                                                                                              if (typeof match$7 === "number" || !(match$7.tag === /* String */2 && !match$5[1])) {
                                                                                                                return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                                              } else {
                                                                                                                return /* tuple */[
                                                                                                                        /* V_literal */Block.__(5, [/* String */Block.__(2, [StringHelper.addQueryParam(match$1[0], match$4[0], match$7[0])])]),
                                                                                                                        /* No_term */0
                                                                                                                      ];
                                                                                                              }
                                                                                                            }
                                                                                                          } else {
                                                                                                            return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                    } else {
                                                                                                      return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              } else {
                                                                                                return Runtime_common$BwaxMobile.invalid_args("addQueryParam");
                                                                                              }
                                                                                            }))
                                                                                    ],
                                                                                    /* :: */[
                                                                                      /* tuple */[
                                                                                        "removeQueryParam",
                                                                                        Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                                                                                if (param) {
                                                                                                  var match = param[0][0];
                                                                                                  if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                                                                    return Runtime_common$BwaxMobile.invalid_args("removeQueryParam");
                                                                                                  } else {
                                                                                                    var match$1 = match[0];
                                                                                                    if (typeof match$1 === "number" || match$1.tag !== /* String */2) {
                                                                                                      return Runtime_common$BwaxMobile.invalid_args("removeQueryParam");
                                                                                                    } else {
                                                                                                      var match$2 = param[1];
                                                                                                      if (match$2) {
                                                                                                        var match$3 = match$2[0][0];
                                                                                                        if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
                                                                                                          return Runtime_common$BwaxMobile.invalid_args("removeQueryParam");
                                                                                                        } else {
                                                                                                          var match$4 = match$3[0];
                                                                                                          if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
                                                                                                            return Runtime_common$BwaxMobile.invalid_args("removeQueryParam");
                                                                                                          } else {
                                                                                                            return /* tuple */[
                                                                                                                    /* V_literal */Block.__(5, [/* String */Block.__(2, [StringHelper.removeQueryParam(match$1[0], match$4[0])])]),
                                                                                                                    /* No_term */0
                                                                                                                  ];
                                                                                                          }
                                                                                                        }
                                                                                                      } else {
                                                                                                        return Runtime_common$BwaxMobile.invalid_args("removeQueryParam");
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                } else {
                                                                                                  return Runtime_common$BwaxMobile.invalid_args("removeQueryParam");
                                                                                                }
                                                                                              }))
                                                                                      ],
                                                                                      /* :: */[
                                                                                        /* tuple */[
                                                                                          "isValidHttpURL",
                                                                                          Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                                                                                  if (param) {
                                                                                                    var match = param[0][0];
                                                                                                    if (typeof match === "number" || match.tag !== /* V_literal */5) {
                                                                                                      return Runtime_common$BwaxMobile.invalid_args("isValidHttpURL");
                                                                                                    } else {
                                                                                                      var match$1 = match[0];
                                                                                                      if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
                                                                                                        return Runtime_common$BwaxMobile.invalid_args("isValidHttpURL");
                                                                                                      } else {
                                                                                                        return /* tuple */[
                                                                                                                /* V_literal */Block.__(5, [/* Bool */Block.__(4, [StringHelper.isValidHttpURL(match$1[0])])]),
                                                                                                                /* No_term */0
                                                                                                              ];
                                                                                                      }
                                                                                                    }
                                                                                                  } else {
                                                                                                    return Runtime_common$BwaxMobile.invalid_args("isValidHttpURL");
                                                                                                  }
                                                                                                }))
                                                                                        ],
                                                                                        /* [] */0
                                                                                      ]
                                                                                    ]
                                                                                  ]
                                                                                ]
                                                                              ]
                                                                            ]
                                                                          ]
                                                                        ]
                                                                      ]
                                                                    ]
                                                                  ]
                                                                ]
                                                              ]
                                                            ]
                                                          ]
                                                        ]
                                                      ]
                                                    ]
                                                  ]
                                                ]
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var externals_vals = /* :: */[
  externals_vals_000,
  externals_vals_001
];

var externals_000 = "String";

var externals = /* tuple */[
  externals_000,
  externals_vals
];

var src = "\nmodule String;\n\n-- Get the length of a string.\nlength: String -> Int = external;\n\n-- Determine if a string is empty.\nisEmpty s: String -> Bool = length s == 0;\n\n-- Repeat a string n times.\nrepeat: Int -> String -> String = external;\n\n-- Reverse a string.\nreverse str: String -> String = external;\n\n-- Replace all occurrences of some substring.\nreplace: String -> String -> String -> String = external;\n\n-- Split a string using a given separator.\nsplit: String -> String -> List String = external;\n\n-- Put many strings together with a given separator.\njoin: String -> List String -> String = external;\n\n-- Append two strings. You can also use the (++) operator to do this.\nappend s1 s2: String -> String -> String = s1 ++ s2;\n\n-- substrings:\n\n-- Take a substring given a start and end index. Negative indexes are taken starting from the end of the list.\nslice: Int -> Int -> String -> String = external;\n\n-- Take n characters from the left side of a string.\nleft: Int -> String -> String = external;\n\n-- Take n characters from the right side of a string.\nright: Int -> String -> String = external; \n\n-- Drop n characters from the left side of a string.\ndropLeft: Int -> String -> String = external;\n\n-- Drop n characters from the right side of a string.\ndropRight: Int -> String -> String = external;\n\n-- See if the second string contains the first one.\ncontains: String -> String -> Bool = external;\n\n-- See if the second string starts with the first one. \nstartsWith: String -> String -> Bool = external;\n\n-- See if the second string ends with the first one.\nendsWith: String -> String -> Bool = external;\n\n-- Get all of the indexes for a substring in another string.\nindexes: String -> String -> List Int = external;\n\n-- conversion:\n\n-- Try to convert a string into an int, failing on improperly formatted strings.\ntoInt: String -> Maybe Int = external;\n\n-- Convert an Int to a String.\nfromInt: Int -> String = external;\n\n-- Try to convert a string into a float, failing on improperly formatted strings.\ntoFloat: String -> Maybe Float = external;\n\n-- Convert a Float to a String.\nfromFloat: Float -> String = external;\n\n-- char related:\n\n-- Create a string from a given character.\nfromChar:Char -> String = external;\n\n-- Add a character to the beginning of a string.\ncons: Char -> String -> String = external;\n\n-- Split a non-empty string into its head and tail. \n-- This lets you pattern match on strings exactly as you would with lists.\nuncons: String -> Maybe (Char, String) = external;\n\n-- Convert a string to a list of characters.\ntoList: String -> List Char = external;\n\n-- Convert a list of characters into a String. \n-- Can be useful if you want to create a string primarily by consing, perhaps for decoding something.\nfromList: List Char -> String = external;\n\n--- formatting:\ntoUpper: String -> String = external;\ntoLower: String -> String = external;\n\ncapitalize: String -> String = external;\nuncapitalize: String -> String = external;\n\n-- Pad a string on both sides until it has a given length.\npad: Int -> Char -> String -> String = external;\n\n-- Pad a string on the left until it has a given length.\npadLeft: Int -> Char -> String -> String = external;\n\n-- Pad a string on the right until it has a given length.\npadRight: Int -> Char -> String -> String = external;\n\n\ntrim: String -> String = external;\ntrimLeft: String -> String = external;\ntrimRight: String -> String = external;\n\n\n\n-- higher order functions\n\n\nmap f str: (Char -> Char) -> String -> String =\n  str |> toList\n      |> List.map f\n      |> fromList       \n;\n\nfilter f str: (Char -> Bool) -> String -> String =\n  str |> toList\n      |> List.filter f\n      |> fromList\n;\n\nfoldl f init str: (b -> Char -> b) -> b -> String -> b =\n  str |> toList\n      |> List.foldl f init\n;\n\nfoldr f str init: (Char -> b -> b) -> String -> b -> b =\n  List.foldr \n    f\n    (toList str)\n    init\n;\n\nany f str: (Char -> Bool) -> String -> Bool =\n  str |> toList\n      |> List.any f\n;\n\nall f str: (Char -> Bool) -> String -> Bool =\n  str |> toList\n      |> List.all f\n;\n\n--- base 64 related\ntoBase64: String -> String = external;\n\ntoBase64URI: String -> String = external;\n\nfromBase64: String -> String = external;\n\n--- URL related\nencodeURI: String -> String = external;\ndecodeURI: String -> String = external;\n\nencodeURIComponent: String -> String = external;\ndecodeURIComponent: String -> String = external;\n\n\n-- name -> param -> url\naddQueryParam: String -> String -> String -> String = external;\n\n-- name -> url\nremoveQueryParam: String -> String -> String = external;\n\n-- \nisValidHttpURL: String -> Bool = external;\n\n\n-- See https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript\nhashCode: String -> Int = external;\n\n\n";

exports.src = src;
exports.toBase64 = toBase64;
exports.toBase64URI = toBase64URI;
exports.fromBase64 = fromBase64;
exports.addQueryParam = addQueryParam;
exports.removeQueryParam = removeQueryParam;
exports.isValidHttpURL = isValidHttpURL;
exports.hashCode = hashCode;
exports.fail = fail;
exports.int_to_string_to_string = int_to_string_to_string;
exports.string_to_string_to_bool = string_to_string_to_bool;
exports.string_to_string = string_to_string;
exports.string_to_int = string_to_int;
exports.int_char_string_string = int_char_string_string;
exports.externals_vals = externals_vals;
exports.externals = externals;
/* externals_vals Not a pure module */
